import React, { useState } from 'react';
import s from './FAQ.module.css';

import img1 from '../images/הבית של זוהר 3.webp';
import img2 from '../images/הבית של גילה 5.webp';
import img3 from '../images/הבית של סיון 10.webp';
import img4 from '../images/הבית של זוהר 18.webp';
import img5 from '../images/הבית של גילה 12.webp';
import img6 from '../images/הבית של סיון 20.webp';
import img7 from '../images/הבית של זוהר 25.webp';

const QUESTIONS = [
  {
    q: 'איך מתחילים תהליך תכנון בית?',
    a: 'בפגישות הראשונות אני מקדישה זמן להכיר אתכם - איך נראים חיי היומיום שלכם ומהם מצבי הקיצון שהבית צריך להכיל, איך אתם מארחים, איך אתם מבשלים, צופים בטלוויזיה, ישנים וקמים, מה חשוב לכם בבית, מה חסר לכם היום ומה הדברים שלא תרצו להתפשר עליהם. במקביל אני לומדת את המגרש, את הסביבה, את התב״ע ואת המגבלות וההזדמנויות שהתכנון מציע. רק אחרי שיש לי תמונה מלאה של האנשים ושל המקום, אני מתחילה לתכנן. בשלב הראשון אני מציגה בדרך כלל שתי חלופות תכנון שונות מהותית זו מזו, שמאפשרות לבחון אפשרויות העמדה שונות, יחסים בין חללים, כיווני אוויר ואור, ורעיונות תכנוניים ועיצוביים שונים. משם אנחנו מתקדמים יחד עם האופציה הנבחרת או שילוב של השתיים, עד שמגיעים להשלמת התוכנית המדויקת לכם ולסגנון החיים שלכם.',
    img: img1,
  },
  {
    q: 'כמה זמן אורך תהליך תכנון ובנייה מלא?',
    a: 'תהליך מלא של תכנון ובנייה נמשך בדרך כלל בין שנה וחצי לשלוש שנים, בהתאם לגודל הפרויקט ולמורכבותו. שלב התכנון עצמו אורך בין שלושה לשישה חודשים, והוא כולל אפיון מעמיק של החזון והצרכים, הכנת תכניות עבודה מפורטות וליווי מול רשויות הרישוי.',
    img: img2,
  },
  {
    q: 'האם תהליך העבודה כולל גם עיצוב פנים?',
    a: 'בהחלט. אני מאמינה שתכנון הבית ועיצוב הפנים הם חלקים של אותו תהליך ולא שני שלבים נפרדים. לאחר גיבוש התכנון האדריכלי אני ממשיכה יחד איתכם לתכנון כל המרכיבים הקבועים בבית: חומרי הגמר, המטבח, חדרי הרחצה, הנגרות המותאמת אישית, התאורה, התקרות, הריצופים ופרטים נוספים שמשפיעים על האופן שבו הבית נראה, מרגיש ומתפקד. מבחינתי ההחלטות האלה הן לא קישוט שמתווסף בסוף התכנון, אלא חלק בלתי נפרד מהתכנון השלם של הבית. לעומת זאת, אני לא עוסקת בהלבשת הבית - בחירת רהיטים, טקסטיל, אקססוריז וחפצי נוי. המיקוד שלי הוא בתכנון ובעיצוב כל מה שבנוי ומחובר לבית, כך שתתקבל מעטפת שלמה, מדויקת וקוהרנטית כבר משלב התכנון ועד לביצוע.',
    img: img3,
  },
  {
    q: 'האם את מלווה גם את שלב הביצוע בשטח?',
    a: 'האחריות שלי לא מסתיימת עם מסירת סט תוכניות העבודה. אני ממשיכה ללוות את הפרויקט לאורך שלבי הביצוע בפועל, עד שהתכנון הופך למציאות בנויה, במעורבות שוטפת מול מפקח הבנייה, הקבלן ובעלי המקצוע השונים. אני רואה חשיבות גדולה בנוכחות בשטח, בזיהוי מוקדם של בעיות, במתן מענה לשאלות שמתעוררות תוך כדי עבודה ובקבלת החלטות בזמן אמת כאשר המציאות מחייבת התאמות או פתרונות חדשים. אני מכירה את הפרויקט לעומק, את ההיגיון שמאחורי כל החלטה תכנונית ואת המטרות שהוגדרו בתחילת הדרך, ולכן אני כאן כדי לשמור על הכיוון הנכון גם ברגעים המורכבים והלחוצים שמלווים כמעט כל תהליך בנייה. הניסיון שלי לימד אותי שלא מעט מההחלטות החשובות ביותר מתקבלות דווקא באתר עצמו, לכן אני מקפידה להיות מעורבת, נגישה ושותפה פעילה לתהליך, עד שהבית עומד בנוי ומממש את כל מה שחלמנו שיהיה.',
    img: img4,
  },
  {
    q: 'האם אפשר להגיע רק לייעוץ חד-פעמי?',
    a: 'לגמרי כן. לא כל מי שפונה אליי נמצא בשלב שבו הוא זקוק לתהליך תכנון מלא. לפעמים מדובר בהתלבטות לפני רכישת מגרש, בית או דירה, ברצון להבין את פוטנציאל הנכס, בבחינת אפשרויות לשיפוץ, או בצורך לקבל חוות דעת נוספת על תכנון שכבר נעשה. למקרים כאלה אני מציעה פגישת ייעוץ ממוקדת, שנמשכת כשלוש שעות ומתקיימת במשרד או בשטח. במהלך הפגישה אנחנו מעלים את כל הסוגיות, ההתלבטויות והשאלות שמעסיקות אתכם, ובוחנים יחד את האפשרויות השונות - תכנונית, עיצובית ומעשית. המטרה היא לא רק לענות על שאלה נקודתית, אלא לתת לכם כיוון, כלים ובהירות לקראת ההחלטות הבאות. פעמים רבות פגישה כזו יכולה לחסוך הרבה זמן, כסף והתלבטויות בהמשך הדרך.',
    img: img5,
  },
  {
    q: 'האם ניתן לעצב חלל בודד בלבד?',
    a: 'הסטודיו נענה לפרויקטים של חלל בודד כאשר מדובר בשינוי משמעותי ומהותי - מטבח-סלון, חדר רחצה או סוויטת הורים. פרויקטים של ריענון קוסמטי אינם נכללים בתחום העיסוק. הדגש מושם על שינויים שמעצבים מחדש את התחושה ואת השימושיות של החלל.',
    img: img6,
  },
  {
    q: 'האם לסטודיו ניסיון בפרויקטים בקנה מידה גדול?',
    a: 'לסטודיו ניסיון עשיר בפרויקטים בקנה מידה גדול: שתי שכונות מגורים שלמות תוכננו ביקנעם המושבה ובקרית טבעון, לצד מתחמי נחלה מלאים הכוללים בית מגורים, אורווה וחללים נלווים - היקפים שאינם נפוצים בארץ. למעלה מחמישים פרויקטים ושש-עשרה שנות ניסיון מהווים בסיס מקצועי איתן לכל פרויקט חדש.',
    img: img7,
  },
];

export default function FAQ({ onOpenLead }) {
  const [open, setOpen] = useState(null);
  const toggle = (i) => setOpen(open === i ? null : i);

  return (
    <section className={s.section}>
      <div className={s.inner}>
        <div className={s.header}>
          <h2 className={s.heading}>שאלות נפוצות</h2>
          <p className={s.sub}>מענה מקיף לשאלות הנפוצות ביותר על תהליך התכנון, העיצוב והליווי</p>
        </div>

        <div className={s.list}>
          {QUESTIONS.map((item, i) => (
            <div
              key={i}
              className={`${s.item} ${open === i ? s.itemOpen : ''} ${s[`side${i % 2}`]}`}
              onClick={() => toggle(i)}
            >
              <figure className={s.frame} aria-hidden="true">
                <img src={item.img} alt="" loading="lazy" />
              </figure>

              <div className={s.question}>
                <h3 className={s.qText}>{item.q}</h3>
                <div className={s.qIcon}>
                  <span className={s.qLine} />
                  <span className={`${s.qLine} ${s.qLineV}`} />
                </div>
              </div>
              <div className={s.answer}>
                <p className={s.aText}>{item.a}</p>
              </div>
            </div>
          ))}
        </div>

        <div className={s.cta}>
          <span className={s.ctaCorner} />
          <span className={`${s.ctaCorner} ${s.ctaCornerBR}`} />
          <div className={s.ctaBody}>
            <h3 className={s.ctaP}>לא נמצא מענה לשאלה?</h3>
            <p className={s.ctaSub}>הסטודיו זמין לפניות ולתיאום פגישת היכרות, בה ייערך אפיון ראשוני של החזון, אורח החיים והצרכים.</p>
          </div>
          <button
            type="button"
            className={s.ctaBtn}
            onClick={onOpenLead}
          >
            <span className={s.ctaBtnLabel}>פנייה לסטודיו</span>
            <span className={s.ctaArrow} aria-hidden="true">←</span>
          </button>
        </div>
      </div>
    </section>
  );
}
